import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "aspect-w-16 aspect-h-16" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "overflow-hidden my-2 whitespace-nowrap overflow-ellipsis" }
const _hoisted_4 = { class: "my-2" }

import { computed } from "vue";

import { IProduct } from "@/interfaces/IProduct";
import { useStore } from "vuex";
import { getProductImage } from "@/helpers/get-product-image";

interface Props {
  product: IProduct;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
  product: IProduct;
}



const store = useStore();

const productImageUrl = computed(() =>
  getProductImage(props.product.image.url)
);

const shoppingCartList = computed(() => store.state.shoppingCartList);

const addedInCart = computed(() =>
  shoppingCartList.value.find(
    (product: IProduct) => product.id === props.product.id
  )
);

const openProductDialog = () => {
  document.querySelector("html")?.classList.add("headless-ui-dialog-fix");
  store.commit("SET_OPENING_PRODUCT", props.product);
  store.commit("TOGGLE_PRODUCT_DIALOG");
};

const addToCart = () => {
  if (addedInCart.value !== undefined) {
    store.dispatch("updateQuantity", {
      productId: props.product.id,
      type: "+",
    });
  } else {
    store.commit("ADD_TO_CART", props.product);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "cursor-pointer",
      onClick: openProductDialog
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", { src: _unref(productImageUrl) }, null, 8, _hoisted_2)
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.product.name), 1),
      _createElementVNode("div", _hoisted_4, "$ " + _toDisplayString(__props.product.price), 1)
    ]),
    _createElementVNode("button", {
      class: "p-2.5 w-full text-white uppercase bg-primary",
      onClick: addToCart
    }, " Add To Cart ")
  ]))
}
}

})